// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScienceCarbonTrend = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.906 2.25a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V4.656l-3.85 3.895-.011.01a1.701 1.701 0 0 1-2.372 0l-.003-.002-1.25-1.228a.2.2 0 0 0-.277-.001l-3.794 3.744a.5.5 0 0 1-.707-.004l-.351-.356a.5.5 0 0 1 .004-.707l3.8-3.75a1.699 1.699 0 0 1 2.373 0l.002.002 1.25 1.228a.201.201 0 0 0 .276.003l3.697-3.74h-1.287a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5zM5 13.25a.75.75 0 0 1 .696.471l2 5A.75.75 0 0 1 7 19.75H6v1.75a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1.75H3a.75.75 0 0 1-.696-1.029l2-5A.75.75 0 0 1 5 13.25zm.892 5L5 16.02l-.892 2.23zm8.83.544a.75.75 0 0 1-.722.956h-1v1.75a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1.75h-1a.75.75 0 0 1-.721-.956l2-7a.75.75 0 0 1 1.442 0zm-1.716-.544L12 14.73l-1.006 3.52H13zm5.994-9a.75.75 0 0 1 .732.587l2 9a.75.75 0 0 1-.732.913h-1v1.75a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1.75h-1a.75.75 0 0 1-.732-.913l2-9A.75.75 0 0 1 19 9.25zm-1 9h2.065L19 13.457l-1.065 4.793z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgScienceCarbonTrend;
